import { page as pageIndex, globals } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import { returnRegions } from './regions'
import { RETURN_INITIAL_STATE } from './queriesFormData'
import { showModal, hideModal } from './modal'
import { logOut } from './auth'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_SPONSOR_RESULTS_START = 'GET_SPONSOR_RESULTS_START'
export const GET_UNMATCHED_SPONSORS_START = 'GET_UNMATCHED_SPONSORS_START'
export const GET_UNMATCHED_SPONSORS_FETCHED = 'GET_UNMATCHED_SPONSORS_FETCHED'
export const GET_UNMATCHED_SPONSORS_FAILURE = 'GET_UNMATCHED_SPONSORS_FAILURE'

export const SET_CREATE_LEGISLATOR = 'SET_CREATE_LEGISLATOR'
export const SET_CREATE_LEGISLATOR_FAILURE = 'SET_CREATE_LEGISLATOR_FAILURE'
export const SET_CREATE_COMMITTEE = 'SET_CREATE_COMMITTEE'
export const SET_CREATE_COMMITTEE_FAILURE = 'SET_CREATE_COMMITTEE_FAILURE'

export const GET_BILL_FETCHED = 'GET_BILL_FETCHED'
export const GET_BILL_START = 'GET_BILL_START'
export const GET_BILL_FAILURE = 'GET_BILL_FAILURE'
export const SEARCH_LEGISLATOR_START = 'SEARCH_LEGISLATOR_START'
export const SEARCH_LEGISLATOR_FETCHED = 'SEARCH_LEGISLATOR_FETCHED'
export const SEARCH_LEGISLATOR_FAILURE = 'SEARCH_LEGISLATOR_FAILURE'
export const SEARCH_COMMITTEE_START = 'SEARCH_COMMITTEE_START'
export const SEARCH_COMMITTEE_FETCHED = 'SEARCH_COMMITTEE_FETCHED'
export const SEARCH_COMMITTEE_FAILURE = 'SEARCH_COMMITTEE_FAILURE'
export const LOOKUP_BILLS_START = 'LOOKUP_BILLS_START'
export const LOOKUP_BILLS_FETCHED = 'LOOKUP_BILLS_FETCHED'
export const LOOKUP_BILLS_FAILURE = 'LOOKUP_BILLS_FAILURE'
export const CREATE_LEGISLATOR_ALIAS_START = 'CREATE_LEGISLATOR_ALIAS_START'
export const LEGISLATOR_ALIAS_CREATED = 'LEGISLATOR_ALIAS_CREATED'
export const CREATE_LEGISLATOR_ALIAS_FAILURE = 'CREATE_LEGISLATOR_ALIAS_FAILURE'
export const DELETE_LEGIS_ALIAS_START = 'DELETE_LEGIS_ALIAS_START'
export const LEGIS_ALIAS_DELETED = 'LEGIS_ALIAS_DELETED'
export const DELETE_LEGIS_ALIAS_FAILURE = 'DELETE_LEGIS_ALIAS_FAILURE'
export const CREATE_COMMITTEE_ALIAS_START = 'CREATE_COMMITTEE_ALIAS_START'
export const COMMITTEE_ALIAS_CREATED = 'COMMITTEE_ALIAS_CREATED'
export const CREATE_COMMITTEE_ALIAS_FAILURE = 'CREATE_COMMITTEE_ALIAS_FAILURE'
export const DELETE_COMMITTEE_ALIAS_START = 'DELETE_COMMITTEE_ALIAS_START'
export const COMMITTEE_ALIAS_DELETED = 'COMMITTEE_ALIAS_DELETED'
export const DELETE_COMMITTEE_ALIAS_FAILURE = 'DELETE_COMMITTEE_ALIAS_FAILURE'
export const ESTABLISH_LEGISLATORS_START = 'ESTABLISH_LEGISLATORS_START'
export const LEGISLATORS_ESTABLISHED = 'LEGISLATORS_ESTABLISHED'
export const ESTABLISH_LEGISLATORS_FAILURE = 'ESTABLISH_LEGISLATORS_FAILURE'
export const DELETE_LEGISLATORS_START = 'DELETE_LEGISLATORS_START'
export const LEGISLATORS_DELETED = 'LEGISLATORS_DELETED'
export const DELETE_LEGISLATORS_FAILURE = 'DELETE_LEGISLATORS_FAILURE'
export const ESTABLISH_COMMITTEES_START = 'ESTABLISH_COMMITTEES_START'
export const COMMITTEES_ESTABLISHED = 'COMMITTEES_ESTABLISHED'
export const ESTABLISH_COMMITTEES_FAILURE = 'ESTABLISH_COMMITTEES_FAILURE'
export const DELETE_COMMITTEES_START = 'DELETE_COMMITTEES_START'
export const COMMITTEES_DELETED = 'COMMITTEES_DELETED'
export const DELETE_COMMITTEES_FAILURE = 'DELETE_COMMITTEES_FAILURE'
export const HIDE_BILL_START = 'HIDE_BILL_START'
export const HIDE_BILL_SUCCESS = 'HIDE_BILL_SUCCESS'
export const HIDE_BILL_FAILURE = 'HIDE_BILL_FAILURE'
export const CREATE_NEW_COMMITTEE_START = 'CREATE_NEW_COMMITTEE_START'
export const NEW_COMMITTEE_CREATED = 'NEW_COMMITTEE_CREATED'
export const CREATE_NEW_COMMITTEE_FAILURE = 'CREATE_NEW_COMMITTEE_FAILURE'
export const CLEAR_CREATION_MODALS = 'CLEAR_CREATION_MODALS'
export const CREATE_NEW_LEGISLATOR_START = 'CREATE_NEW_LEGISLATOR_START'
export const NEW_LEGISLATOR_CREATED = 'NEW_LEGISLATOR_CREATED'
export const CREATE_NEW_LEGISLATOR_FAILURE = 'CREATE_NEW_LEGISLATOR_FAILURE'
export const DUPLICATED_SPONSOR = 'DUPLICATED_SPONSOR'
export const DUPLICATED_ALIAS = 'DUPLICATED_ALIAS'

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  fetchUnmatchedSponsors,
  fetchUnmatchedBill,
  searchLegislators,
  searchCommittees,
  lookupBill,
  openLookupBill,
  returnListOfStates
}

const headers = {
  'Content-Type': 'application/json'
}

export function fetchUnmatchedSponsors (state) {
  return (dispatch) => {
    dispatch({ type: GET_UNMATCHED_SPONSORS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/unmatchedsponsor?state=${state === 'all' ? '' : state}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_UNMATCHED_SPONSORS_FETCHED,
          payload: {
            json,
            region: state
          }
        })
        dispatch(fetchUnmatchedBill(json[0], 0))
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_UNMATCHED_SPONSORS_FAILURE })
    })
  }
}

export function fetchUnmatchedBill (sponsorInfo, index) {
  return (dispatch) => {
    dispatch({ type: GET_BILL_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    let state = 'state='
    let sponsorfirstname = '&sponsorfirstname='
    let sponsor = '&sponsor='
    let chamber = '&chamber='
    if (sponsorInfo !== undefined) {
      state = `state=${sponsorInfo.State || ''}`
      sponsorfirstname = `&sponsorfirstname=${sponsorInfo.SponsorFirstName
        ? encodeURIComponent(sponsorInfo.SponsorFirstName) : ''}`
      sponsor = `&sponsor=${sponsorInfo.Sponsor ? encodeURIComponent(sponsorInfo.Sponsor) : ''}`
      chamber = `&chamber=${sponsorInfo.Chamber || ''}`
    }
    const parameters = state + sponsorfirstname + sponsor + chamber
    fetch(`${globals.apiUrl}/sponsorreview/unmatchedbill?${parameters}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_BILL_FETCHED,
          payload: {
            json,
            selectedBill: index,
            sponsorInfo
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_BILL_FAILURE })
    })
  }
}

export function searchLegislators (state, name) {
  return (dispatch) => {
    dispatch({ type: SEARCH_LEGISLATOR_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/searchlegislator?state=${state}&value=${name}&active=0`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SEARCH_LEGISLATOR_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SEARCH_LEGISLATOR_FAILURE })
    })
  }
}

export function searchCommittees (state, name) {
  return (dispatch) => {
    dispatch({ type: SEARCH_COMMITTEE_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/searchcommittee?state=${state}&value=${name}&active=0`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SEARCH_COMMITTEE_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SEARCH_COMMITTEE_FAILURE })
    })
  }
}

export function lookupBill (billInfo) {
  return (dispatch) => {
    dispatch({ type: LOOKUP_BILLS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const state = `state=${billInfo.state}`
    const session = `&session=${billInfo.session}`
    const billType = `&billtype=${billInfo.billType}`
    const billNumber = `&billnumber=${billInfo.billNumber}`
    const parameters = state + session + billType + billNumber
    fetch(`${globals.apiUrl}/sponsorreview/billlookup?${parameters}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: LOOKUP_BILLS_FETCHED,
          payload: {
            json
          }
        })
        if (json.length !== 0) {
          dispatch({
            type: GET_BILL_FETCHED,
            payload: {
              json: [json[0]],
              selectedBill: 0
            }
          })
        } else {
          dispatch(showModal('No-results'))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: LOOKUP_BILLS_FAILURE })
    })
  }
}

export function openLookupBill (array, index) {
  return (dispatch) => {
    dispatch({ type: GET_BILL_START })
    setTimeout(() => dispatch({
      type: GET_BILL_FETCHED,
      payload: {
        json: Array.isArray(array) ? [array[index]] : [array],
        selectedBill: index
      }
    }), 500)
  }
}

export function createLegislatorAlias (legislatorAlias) {
  return (dispatch) => {
    dispatch({ type: CREATE_LEGISLATOR_ALIAS_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(legislatorAlias)
    }
    fetch(`${globals.apiUrl}/sponsorreview/LegislatorAlias`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        dispatch({ type: DUPLICATED_ALIAS, json: legislatorAlias })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: LEGISLATOR_ALIAS_CREATED,
          payload: {
            json
          }
        })
        localStorage.removeItem('autoPopulateAlias')
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_LEGISLATOR_ALIAS_FAILURE })
    })
  }
}

export function removeLegislatorAlias (referenceLegislatorAliasId, searchOptions) {
  return (dispatch) => {
    dispatch({ type: DELETE_LEGIS_ALIAS_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/LegislatorAlias?referencelegislatoraliasid=${referenceLegislatorAliasId}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: LEGIS_ALIAS_DELETED,
          payload: {
            json
          }
        })
        const { searchState, searchInput } = searchOptions
        dispatch(searchLegislators(searchState, searchInput))
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_LEGIS_ALIAS_FAILURE })
    })
  }
}

export function createCommitteeAlias (committeeAlias) {
  return (dispatch) => {
    dispatch({ type: CREATE_COMMITTEE_ALIAS_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(committeeAlias)
    }
    fetch(`${globals.apiUrl}/sponsorreview/CommitteeAlias`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        dispatch({ type: DUPLICATED_ALIAS, json: committeeAlias })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: COMMITTEE_ALIAS_CREATED,
          payload: {
            json
          }
        })
        localStorage.removeItem('autoPopulateAlias')
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_COMMITTEE_ALIAS_FAILURE })
    })
  }
}

export function removeCommitteeAlias (referenceCommitteeAliasId, searchOptions) {
  return (dispatch) => {
    dispatch({ type: DELETE_COMMITTEE_ALIAS_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/CommitteeAlias?referencecommitteealiasid=${referenceCommitteeAliasId}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: COMMITTEE_ALIAS_DELETED,
          payload: {
            json
          }
        })
        const { searchState, searchInput } = searchOptions
        dispatch(searchCommittees(searchState, searchInput))
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_COMMITTEE_ALIAS_FAILURE })
    })
  }
}

export function establishLegislator (legislationSponsorData) {
  return (dispatch) => {
    dispatch({ type: ESTABLISH_LEGISLATORS_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(legislationSponsorData)
    }
    fetch(`${globals.apiUrl}/sponsorreview/BillLegislator`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: LEGISLATORS_ESTABLISHED,
          payload: {
            json
          }
        })
        if (localStorage.getItem('signOut')) {
          dispatch(logOut())
          localStorage.removeItem('signOut')
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ESTABLISH_LEGISLATORS_FAILURE })
    })
  }
}

export function removeLegislator (RawFileId, ReferenceLegislatorId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LEGISLATORS_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    const rawFileId = `rawfileid=${RawFileId}`
    const referenceLegislatorId = `referencelegislatorid=${ReferenceLegislatorId}`
    fetch(`${globals.apiUrl}/sponsorreview/BillLegislator?${rawFileId}&${referenceLegislatorId}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: LEGISLATORS_DELETED,
          payload: {
            json,
            RawFileId
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_LEGISLATORS_FAILURE })
    })
  }
}

export function establishCommittee (committeeData) {
  return (dispatch) => {
    dispatch({ type: ESTABLISH_COMMITTEES_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(committeeData)
    }
    fetch(`${globals.apiUrl}/sponsorreview/BillCommittee`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: COMMITTEES_ESTABLISHED,
          payload: {
            json
          }
        })
        if (localStorage.getItem('signOut')) {
          dispatch(logOut())
          localStorage.removeItem('signOut')
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ESTABLISH_COMMITTEES_FAILURE })
    })
  }
}

export function removeCommittee (RawFileId, ReferenceCommitteeId) {
  return (dispatch) => {
    dispatch({ type: DELETE_COMMITTEES_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    const rawFileId = `rawfileid=${RawFileId}`
    const referenceCommitteeId = `referencecommitteeid=${ReferenceCommitteeId}`
    fetch(`${globals.apiUrl}/sponsorreview/BillCommittee?${rawFileId}&${referenceCommitteeId}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: COMMITTEES_DELETED,
          payload: {
            json,
            RawFileId
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_COMMITTEES_FAILURE })
    })
  }
}

export function returnListOfStates (sponsors) {
  let sponsorStates = []
  sponsors.map(item => {
    if (!sponsorStates.find(el => el.state === item.State)) {
      sponsorStates = [...sponsorStates, { state: item.ShortName, fullName: item.Name }]
    }
  })
  const mappedSponsors = sponsorStates.map(elem => {
    return {
      value: elem.state,
      label: `${elem.state} - ${elem.fullName}`
    }
  })
  return mappedSponsors.filter(item => item.Value !== 'All')
}

export function hideBill (billData) {
  return (dispatch) => {
    dispatch({ type: HIDE_BILL_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(billData)
    }
    fetch(`${globals.apiUrl}/sponsorreview/billdisplay`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: HIDE_BILL_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: HIDE_BILL_FAILURE })
    })
  }
}

export function createNewCommittee (committeeCM, id, state, name) {
  return (dispatch) => {
    dispatch({ type: CREATE_NEW_COMMITTEE_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(committeeCM)
    }
    fetch(`${globals.apiUrl}/sponsorreview/committee`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            return dispatch({ type: DUPLICATED_SPONSOR, text })
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: NEW_COMMITTEE_CREATED,
          payload: {
            json
          }
        })
        committeeCM.ReferenceCommitteeId ? 
        dispatch(hideModal(`Edit-item-sponsor-${id}`)) : dispatch(hideModal(`Add-new-item-sponsor-${id}`))
        dispatch(searchCommittees(state, name))
        dispatch(clearCreationModals())
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_NEW_COMMITTEE_FAILURE })
    })
  }
}

export function populateCreateLegislator (legislatorCM, id) {
  return (dispatch) => {
    dispatch({
      type: SET_CREATE_LEGISLATOR,
      payload: {
        legislator: legislatorCM
      }
    })
  }
}

export function populateCreateCommittee (committeeCM, id) {
  return (dispatch) => {
    dispatch({
      type: SET_CREATE_COMMITTEE,
      payload: {
        committee: committeeCM
      }
    })
  }
}

  // Create or update a ReferenceLegislator depending on 
  // legislatorCM.ReferenceLegislatorId being populated. 
export function createNewLegislator (legislatorCM, id, state, name) {
  return (dispatch) => {
    dispatch({ type: CREATE_NEW_LEGISLATOR_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(legislatorCM)
    }
    fetch(`${globals.apiUrl}/sponsorreview/legislator`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            return dispatch({ type: DUPLICATED_SPONSOR, text })
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: NEW_LEGISLATOR_CREATED,
          payload: {
            json
          }
        })
        legislatorCM.ReferenceLegislatorId ? 
        dispatch(hideModal(`Edit-item-sponsor-${id}`)) : dispatch(hideModal(`Add-new-item-sponsor-${id}`))
        dispatch(searchLegislators(state, name))
        dispatch(clearCreationModals())
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_NEW_LEGISLATOR_FAILURE })
    })
  }
}

export function clearCreationModals () {
  return {
    type: CLEAR_CREATION_MODALS
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.sponsorInfo
    ? state : actionHandler(state, action),
  [RETURN_INITIAL_STATE] : (state, action) => {
    const { page } = action.payload
    if (page !== pageIndex.sponsorInfo) {
      return {
        ...state
      }
    }
    return {
      ...initialState,
      formDataValue: {
        ...initialState.formDataValue,
        SI: {
          ...initialState.formDataValue.SI,
          queryLine: {
            radio: {
              query: state.formDataValue.SI.queryLine.radio.query,
              sponsorType: state.formDataValue.SI.queryLine.radio.sponsorType
            }
          },
          queriesList: state.formDataValue.SI.queriesList,
          navigation: {
            textValues: {
              currentRecord: state.formDataValue.SI.navigation.textValues.currentRecord
            }
          }
        }
      }
    }
  },
  [GET_SPONSOR_RESULTS_START] : (state) => {
    return {
      ...state,
      isFetchingSponsors: true
    }
  },
  [GET_UNMATCHED_SPONSORS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_UNMATCHED_SPONSORS_FETCHED] : (state, action) => {
    const { json, region } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        amountOfSponsors: json,
        lookupBills: false,
        queriesList: json,
        totalUnmatched: region === 'all' ? json : state.renderData.totalUnmatched
      },
      formDataValue: {
        ...state.formDataValue,
        SI: {
          ...state.formDataValue.SI,
          navigation: {
            textValues: {
              currentRecord: 1
            }
          },
          queriesList: json
        }
      }
    }
  },
  [GET_BILL_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_BILL_FETCHED] : (state, action) => {
    const { json, selectedBill, sponsorInfo } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        sponsorBills: json,
        openedBill: +selectedBill + 1,
        sponsorInfo
      },
      formDataValue: {
        ...state.formDataValue,
        SI: {
          ...state.formDataValue.SI,
          queryLine: {
            ...state.formDataValue.SI.queryLine,
            radio: {
              ...state.formDataValue.SI.queryLine.radio,
              query: sponsorInfo ? sponsorInfo.State : state.formDataValue.SI.queryLine.radio.query
            }
          },
          navigation: {
            textValues: {
              currentRecord: +selectedBill + 1
            }
          }
        }
      }
    }
  },
  [SEARCH_LEGISLATOR_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        sponsorResults: json
      }
    }
  },
  [SEARCH_COMMITTEE_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        sponsorResults: json
      }
    }
  },
  [LOOKUP_BILLS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [LOOKUP_BILLS_FETCHED] : (state, action) => {
    const { json } = action.payload
    if (json.length === 0) {
      delete state.renderData.sponsorInfo
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        amountOfSponsors: json,
        lookupBills: true,
        sponsorBills: json,
        removedSponsor: null,
        removedRawFileId: null
      },
      formDataValue: {
        ...state.formDataValue,
        SI: {
          ...state.formDataValue.SI,
          navigation: {
            textValues: {
              currentRecord: 1
            }
          }
        }
      }
    }
  },
  [CREATE_LEGISLATOR_ALIAS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [LEGISLATOR_ALIAS_CREATED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: true,
      renderData: {
        ...state.renderData,
        newAlias: json,
        duplicatedAlias: null
      }
    }
  },
  [CREATE_COMMITTEE_ALIAS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [COMMITTEE_ALIAS_CREATED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: true,
      renderData: {
        ...state.renderData,
        newAlias: json,
        duplicatedAlias: null
      }
    }
  },
  [LEGIS_ALIAS_DELETED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: true,
      renderData: {
        ...state.renderData,
        deletedAlias: json
      }
    }
  },
  [COMMITTEE_ALIAS_DELETED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: true,
      renderData: {
        ...state.renderData,
        deletedAlias: json
      }
    }
  },
  [ESTABLISH_LEGISLATORS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [LEGISLATORS_ESTABLISHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        establishedSponsor: json,
        removedSponsor: null,
        removedRawFileId: null
      }
    }
  },
  [LEGISLATORS_DELETED] : (state, action) => {
    const { json, RawFileId } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        removedSponsor: json,
        removedRawFileId: RawFileId
      }
    }
  },
  [ESTABLISH_COMMITTEES_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [COMMITTEES_ESTABLISHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        establishedSponsor: json,
        removedSponsor: null,
        removedRawFileId: null
      }
    }
  },
  [COMMITTEES_DELETED] : (state, action) => {
    const { json, RawFileId } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        removedSponsor: json,
        removedRawFileId: RawFileId
      }
    }
  },
  [CLEAR_CREATION_MODALS] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: false
      },
      formDataValue: {
        SI: {
          ...state.formDataValue.SI,
          createCommittee: {
            referenceCommitteeId: 0,
            textValues: {
              name: '',
              chamber: ''
            },
            radio: {
              state: '',
              country: ''
            },
            selected: ['active']
          },
          createLegislator: {
            referenceLegislatorId: 0,
            textValues: {
              title: '',
              firstName: '',
              lastName: '',
              suffix: '',
              yearElected: '',
              currentTermEnds: '',
              streetAddress1: '',
              streetAddress2: '',
              city: '',
              zip: '',
              phone: '',
              fax: '',
              email: '',
              homePage: '',
              imageUrl: '',
              chamber: ''
            },
            radio: {
              state: '',
              party: '',
              country: ''
            },
            selected: ['active']
          }
        }
      }
    }
  },
  'GET_ALL_REGIONS_FETCHED' : (state, action) => {
    const { json } = action.payload
    const regions = returnRegions(json).filter(item => item.value !== 'all')
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRegions: regions
      },
      formDataValue: {
        SI: {
          ...state.formDataValue.SI,
          newSponsor: {
            radio: {
              ...state.formDataValue.SI.newSponsor.radio,
              states: regions
            }
          }
        }
      }
    }
  },
  'FILTER_REGIONS' : (state, action) => {
    const { country, json, page } = action.payload
    if (page !== 'SI') {
      return {
        ...state
      }
    }
    const filteredRegions = country === 'all' ? json : json.filter(item => item.CountryCode === country)
    const regions = returnRegions(filteredRegions).filter(item => item.value !== 'all')
    return {
      ...state,
      renderData: {
        ...state.renderData,
        regions: country === 'all'
          ? state.renderData.regions
          : regions
      },
      formDataValue: {
        SI: {
          ...state.formDataValue.SI,
          queryLine: {
            ...state.formDataValue.SI.queryLine,
            radio: {
              ...state.formDataValue.SI.queryLine.radio,
              query: regions[0].value
            }
          }
        }
      }
    }
  },
  'POLITICAL_PARTIES_FETCHED' : (state, action) => {
    const { json } = action.payload
    const stateValue = state.formDataValue.SI.createLegislator.radio.state
    const politParties = json.find(item => item.ShortName === stateValue).PoliticalParties
    return {
      ...state,
      formDataValue: {
        SI: {
          ...state.formDataValue.SI,
          newSponsor: {
            radio: {
              ...state.formDataValue.SI.newSponsor.radio,
              party: politParties.map(item => {
                return {
                  value: item.Code,
                  label: item.Code
                }
              })
            }
          }
        }
      }
    }
  },
  [CREATE_NEW_COMMITTEE_START] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: false
      }
    }
  },
  [CREATE_NEW_LEGISLATOR_START] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: false
      }
    }
  },
  [NEW_LEGISLATOR_CREATED] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: false
      }
    }
  },
  [CREATE_NEW_LEGISLATOR_FAILURE] : (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        sponsorFailed: action.json
      }
    }
  },
  [NEW_COMMITTEE_CREATED] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: false
      }
    }
  },
  [DUPLICATED_SPONSOR] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        duplicatedSponsor: true,
        errorMessage: action.text
      }
    }
  },
  [DUPLICATED_ALIAS] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        duplicatedAlias: action.json
      }
    }
  },
  [SET_CREATE_LEGISLATOR] : (state, action) => {
    const { legislator } = action.payload
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        SI: {
          ...state.formDataValue.SI,
          createLegislator: {
            referenceLegislatorId: legislator.ReferenceLegislatorId,
            textValues: {
              title: legislator.Title ? legislator.Title : '',
              firstName: legislator.FirstName ? legislator.FirstName : '',
              lastName: legislator.LastName ? legislator.LastName : '',
              suffix: legislator.Suffix ? legislator.Suffix : '',
              yearElected: legislator.StartYear,
              currentTermEnds: legislator.EndYear,
              streetAddress1: legislator.Street1,
              streetAddress2: legislator.Street2,
              city: legislator.City,
              zip: legislator.Zip,
              phone: legislator.Capitol ? legislator.Capitol : '',
              fax: legislator.Fax ? legislator.Fax : '',
              email: legislator.Email ? legislator.Email : '',
              homePage: legislator.Homepage ? legislator.Homepage : '',
              imageUrl: legislator.ImageUrl ? legislator.ImageUrl : '',
              chamber: legislator.Chamber ? legislator.Chamber : ''
            },
            radio: {
              state: legislator.RegionCode,
              party: legislator.Party
            },
            selected: legislator.Active ? ['active'] : [] 
          },
        }
      }
    }
  },  
  [SET_CREATE_COMMITTEE] : (state, action) => {
    const { committee } = action.payload
    const selectedOptions = committee.IsActive == 1 ? ['active'] : [];
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        SI: {
          ...state.formDataValue.SI,
          createCommittee: {
            referenceCommitteeId: committee.ReferenceCommitteeId,
            textValues: {
              name: committee.Name,
              chamber: committee.Chamber,
              jurisdiction: committee.Jurisdiction,
            },
            radio: {
              state: committee.RegionCode,
              country: committee.Country
            },
            selected: committee.IsActive ? ['active'] : []
          },
        }
      }
    }
  }  
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    SI: {
      queryLine: {
        radio: {
          query: 'all',
          sponsorType: 'unmatched',
          country: 'all'
        }
      },
      navigation: {
        textValues: {
          currentRecord: '1'
        }
      },
      sponsorRow: {
        selected: [],
        radio: {
          sponsorSelect: 'Legislators'
        }
      },
      searchType: {
        selected: [],
        textValues: {
          searchInput: '',
          searchState: ''
        }
      },
      aliasFields: {
        textValues: {
          firstName: '',
          lastName: ''
        }
      },
      inactiveMatches: {
        selected: []
      },
      parametersSection: {
        textValues: {
          state: '',
          type: '',
          number: '',
          session: ''
        }
      },
      createCommittee: {
        referenceCommitteeId: 0,
        textValues: {
          name: '',
          chamber: ''
        },
        radio: {
          state: ''
        },
        selected: ['active']
      },
      createLegislator: {
        referenceLegislatorId: 0,
        textValues: {
          title: '',
          firstName: '',
          lastName: '',
          suffix: '',
          yearElected: '',
          currentTermEnds: '',
          streetAddress1: '',
          streetAddress2: '',
          city: '',
          zip: '',
          phone: '',
          fax: '',
          email: '',
          homePage: '',
          imageUrl: '',
          chamber: ''
        },
        radio: {
          state: '',
          party: ''
        },
        selected: ['active']
      },
      newSponsor: {
        radio: {
          party: [],
          states: []
        }
      }
    }
  }
}
export default function sponsorInfoReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/sponsorInfo.js